import React from "react"

const Component = ({ address }) => {
  return (
    <iframe
      src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1225.3603070508188!2d141.30054609200513!3d43.074782617185924!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f0b2909badb5943%3A0x7e77f47fbc62596a!2z5bCx5Yq057aZ57aa5pSv5o-0QeWeiyDjgZXjgaHjgarjgbM!5e0!3m2!1sja!2sjp!4v1724383557915!5m2!1sja!2sjp`}
      width="100%"
      frameborder="0"
      style={{ border: 0, verticalAlign:"bottom", aspectRatio:"4/3", maxWidth:"500px",filter:"hue-rotate(155deg)" }}
      allowfullscreen
      loading="lazy"
      title={`Google Map: 北海道札幌市西区琴似二条6丁目1-25清水ビル401号`}
    />
  )
}

export default Component
